import { useTranslation } from 'react-i18next';
import { DebounceClick } from '@toss/react';
import { useAuth } from '@zep/auth';
import { MailIcon } from '@zep/icons';
import { Button } from '@zep/ui';
interface SharedPlanPaymentButtonProps {
  isButtonDisabled: boolean;
  buttonPrice: number;
  currencyString: string;
  onClick: () => void;
}
export const SharedPlanPaymentButton = ({
  isButtonDisabled,
  buttonPrice,
  currencyString,
  onClick
}: SharedPlanPaymentButtonProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    user
  } = useAuth();
  return <div className="flex w-full items-center" data-sentry-component="SharedPlanPaymentButton" data-sentry-source-file="SharedPlanPaymentButton.tsx">
      <div className="w-full flex-[1.095] justify-end">
        <div className="flex w-full items-center justify-start">
          <span>
            <MailIcon width={14} height={14} data-sentry-element="MailIcon" data-sentry-source-file="SharedPlanPaymentButton.tsx" />
          </span>
          <span className="text-body-2-sb ml-[6px] font-[600] text-gray-600">
            {t('subscription:payment.footer.email', {
            email: user?.snsId,
            defaultValues: '{{email}} 으로 결제 관련된 이메일을 보내드립니다.'
          })}
          </span>
        </div>
      </div>
      <div className="flex-1">
        <div className="pl-[40px]">
          <DebounceClick wait={200} data-sentry-element="DebounceClick" data-sentry-source-file="SharedPlanPaymentButton.tsx">
            <Button className="ml-auto !h-[54px] min-w-[320px] !text-[18px] !font-[700]" disabled={isButtonDisabled} onClick={onClick} data-sentry-element="Button" data-sentry-source-file="SharedPlanPaymentButton.tsx">
              {isButtonDisabled ? t('subscription:payment.title', '결제하기') : t('subscription:payment.footer.pay', {
              defaultValues: '{{price}} 결제하기',
              price: `${currencyString} ${buttonPrice.toLocaleString()}`
            })}
            </Button>
          </DebounceClick>
        </div>
      </div>
    </div>;
};